import type { FilterDataOption } from '@/app/common/filters/core/filtersTypes.ts';
import React from 'react';
import Stars from '@/app/common/components/Stars/index.tsx';
import { NO_STAR_RATING_VALUE } from '@/app/common/filters/core/starsValues.ts';

// LabelNode passes only labelComponent.props, so there is no text to fall back to here.
export const FiltersStarsLabel = (option: FilterDataOption) => (
  <Stars stars={parseInt(option.value, 10)} black={true} />
);

// Keyed by filter name, so this one receives the whole option and can use its label.
export const FiltersStarsBadgeLabel = (option: FilterDataOption) =>
  option.value === NO_STAR_RATING_VALUE ? (
    <span>{option.label}</span>
  ) : (
    <Stars stars={parseInt(option.value, 10)} color="currentColor" />
  );
